import { useCallback } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import AuthenticationTwoFactorPhoneNumberForm from "../Authentication/TwoFactor/AuthenticationTwoFactorPhoneNumberForm";

import { updatePhoneNumber } from "../../mutations/UpdatePhoneNumberMutation";

const PhoneNumberChangeEnrollmentStep = ({ onEnrolled }) => {
  const t = useFormatMessage();
  const helpMessage = t(intlMessages.help);

  const submitPhoneNumber = useCallback(async formState => {
    const { updatePhoneNumber: result } = await updatePhoneNumber(formState);

    return result;
  }, []);

  return (
    <AuthenticationTwoFactorPhoneNumberForm
      submitPhoneNumber={submitPhoneNumber}
      onNumberValidated={onEnrolled}
      helpMessage={helpMessage}
    />
  );
};

export default PhoneNumberChangeEnrollmentStep;

const intlMessages = defineMessages({
  help: {
    id: "profile.phoneNumber.change.help",
    defaultMessage:
      "Saisissez votre nouveau numéro de mobile. Nous vous y enverrons un code de " +
      "vérification."
  }
});
